jQuery(document).ready(function ($) {

  new Splide('.banner', {
    type: 'fade',
    perPage: 1,
    cover: false,
    arrows: false,
    pagination: false,
    autoHeight: true,
    heightRatio: false,
    gap: 0,
    autoplay: true,
    interval: 5000,
    rewind: true,
    // breakpoints: {
    //   768: {
    //     perPage: 1,
    //     pagination: true
    //   },
    //   1024: {
    //     perPage: 2,
    //     pagination: true
    //   },
    // },
    classes: {
      pagination: 'splide__pagination dots hp-splide__pagination', // container
      arrows: 'splide__arrows hp-splide__arrows',
      arrow: 'splide__arrow hp-splide__arrow',
      prev:
        'splide__arrow--prev hp-splide__arrow--prev',
      next: 'splide__arrow--next hp-splide__arrow--next',
      page: 'splide__pagination__page hp-splide__pagination__page',
    },
  }).mount();

  //Offset Homepage Banner if global nav items are present when using Transparent Nav.
  // if ($(window).width() > 1024) {
  //   if ($('.transparent-nav .global-nav.desktop .global-nav__links li').length >= 1) {
  //     console.log("Global nav is present.");
  //     $('.global-nav.desktop ').height(function (index, height) {
  //       $('.banner').css("margin-top", height);
  //       console.log("Added" + " " + height + "px margin-top to banner");
  //     });
  //   }
  // }

  //Offset Header if Alerts are present when using Transparent Nav.
  if ($(window).width() > 1024) {
    if ($('.transparent-nav .alerts').length >= 1) {
      console.log("Alerts is present.");
      $('.alerts').height(function (index, height) {
        $('.header').css("margin-top", height);
        console.log("Added" + " " + height + "px margin-top to banner");
      });
    }
  }

  var featuredPosts = new Splide('.featured-news__news-items', {
    type: 'fade',
    padding: '10%',
    rewind: true,
    arrows: true,
    breakpoints: {
      1024: {
        perPage: 1,
        padding: '4%',
        arrows: false,
        pagination: true,
      },
    },
  });
  featuredPosts.mount();

  //Event Calendar
  $(".day.has-event .day-content").on("focusin", function () {
    $(this).addClass("reveal");
    $(document).click(function () {
      $('.day-content').removeClass('reveal');
    });
    $(document).keydown(function (event) {
      if (event.key === "Escape") {
        $('.day-content').removeClass('reveal');
      }
    });
  });

  $(".day.has-event .day-content__inner a").on("focusout", function () {
    if ($(this).is(":last-child")) {
      $(this).closest(".day-content").removeClass("reveal");
    }
  });

});